import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { InfoLine } from '../InfoSection';
export var isNil = function (value) { return value == null; };
// TODO: review this logic, left untouched from Comments.tsx
export var FooterNotes = function (_a) {
    var footer = _a.footer, metaData = _a.metaData, t = _a.t;
    var _b = metaData !== null && metaData !== void 0 ? metaData : {}, notes = _b.notes, legalTerms = _b.legalTerms;
    var _c = footer !== null && footer !== void 0 ? footer : {}, firstLabel = _c.firstLabel, secondLabel = _c.secondLabel;
    var formattedNotes = ReactHtmlParser(notes);
    var formattedLegalTerms = ReactHtmlParser(legalTerms);
    var showNotesSection = firstLabel || notes;
    var showLegalTermsSection = secondLabel || legalTerms;
    var firstLabelIfNeeded = function () {
        if (!notes) {
            return null;
        }
        else if (isNil(firstLabel)) {
            return t('price-quote.view.notes');
        }
        return firstLabel;
    };
    var secondLabelIfNeeded = function () {
        if (!legalTerms) {
            return null;
        }
        else if (isNil(secondLabel)) {
            return t('price-quote.view.legal-terms');
        }
        return secondLabel;
    };
    var renderFooterSection = function (label, content) { return (React.createElement(React.Fragment, null,
        React.createElement(InfoLine, { subtext: true, weight: "bold", paddingTop: "20px" }, label),
        React.createElement(InfoLine, { subtext: true, listStyle: "circle", paddingTop: "8px" }, content))); };
    if (!notes && !legalTerms) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        showNotesSection &&
            renderFooterSection(firstLabelIfNeeded(), notes ? formattedNotes : null),
        showLegalTermsSection &&
            renderFooterSection(secondLabelIfNeeded(), legalTerms ? formattedLegalTerms : null)));
};
//# sourceMappingURL=FooterNotes.js.map